module.exports = __webpack_public_path__ + "images/emoji/feet.95453b4be02a742a5d34.png";